/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable no-unused-vars */
/* eslint-disable no-unneeded-ternary */
/* eslint-disable no-else-return */
/* eslint-disable no-nested-ternary */
/* eslint-disable prefer-template */
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import ReactPlayer from 'react-player';
import { useSelector, useDispatch } from 'react-redux';
import { NavigateNext, NavigateBefore } from '@material-ui/icons';
import { DocumentViewer } from 'react-documents';
import HeaderBack from '../../../components/headerBack';
import Button from '../../../components/button';
import Loading from '../../../components/loading/loading';
import styles from './detail.module.scss';
import DisplayPDF from './components/DisplayPDF';
import SectionsList from './SectionList';
import StartQuiz from '../Quiz/StartQuiz';
import { fetchTrainingDetail, saveContentInfo, completePortalTraining, fetchTrainingDraft } from '../redux/action';
import { TRAINING_MANAGEMENT_SECTION_DETAILS, PORTAL } from '../../../constants/RouterConstants';
import './training_detail.css';
import Modal from '../../../components/modal';
import FormattedMessageWithClass from '../../../components/formattedMessageWithClass';

const showPrevious = (config, quiz, subId) => {
    if (config?.content_restricted === true
        && Number(quiz?.id) === Number(subId)
    ) {
        return false;
    }
    return true;
};

const TrainingDetail = (props) => {
    let {
        history,
        match: { params },
        isPublic,
        completePublicTraining,
        saveTrainingDraft,
        trainingInfo,
        draftData
    } = props;

    const [loading, setLoading] = useState(false);
    const [numPages, setNumPages] = useState(null);
    const [pageNumber, setPageNumber] = useState(1);
    const [trackingInfo, setTrackingInfo] = useState({});
    const [contentSaveInfo, setContentSaveInfo] = useState({});
    const [tracking, setTracking] = useState([]);
    const [currentAttempts, setCurrentAttempts]=useState(0);
    const [currentQuizz, setCurrentQuizz]=useState(0);
    const [quizzStatus, setQuizzStatus]=useState(0);
    const [quizzResult, setQuizzResult]=useState(0);
    const trainingCompletionStatus = useSelector(state => state?.trainings?.trainingCompletion.success);
    const [playbackObject, setPlaybackObject] = useState([]);
    const [playbackTimeSet, setPlaybackTimeSet] = useState(true);
    const [videoControls, setvideoControls] = useState(true);
    const [watchTime, setWatchTime] = useState(false);
    const [next_section, setNext_Section] = useState(true);
    const [totalQuizz, setTotalQuizz]=useState([]);
    const [openAlert, setOpenAlert] = useState(false);
    const [retakeTrigger, setRetakeTrigger] = useState(0);
    const playerRef = React.useRef(null);
    const autoCompleteTriggered = React.useRef(false);
    const dispatch = useDispatch();

    const trainingDataFromState = useSelector(state => state.trainings.trainingDetail);
    const trainingDraftFromState = useSelector(state => state.trainings.trainingDraft);
    const trainingFetchAction = useSelector(state => state.trainings.trainingFetchAction);
    const trainingPermission = useSelector(state => state.trainings.errorMess);
    const trainingCompletionError = useSelector(state => state?.trainings?.completeTrainingAction.error);

    const trainingData = isPublic ? trainingInfo : trainingDataFromState;
    const trainingDraft = isPublic ? draftData : trainingDraftFromState;
    const isInitialLoadRef = React.useRef(true);

    const actionFetchTrainingDetails = (id) => {
        if (!isPublic) {
            dispatch(fetchTrainingDetail(id));
        }
    };

    const actionContentInfo = (id, data) => {
        if (isPublic) {
            saveTrainingDraft(id, data);
        } else {
            dispatch(saveContentInfo(id, data));
        }
    };

    const actionCompleteTraining = useCallback(
        (id) => {
            if (!isPublic) {
                dispatch(completePortalTraining(id));
            }
        },
        [isPublic, dispatch]
    );

    const actionTrainingDraft = (id) => {
        dispatch(fetchTrainingDraft(id));
    };

    const lastSub = trainingData?.sections?.length
        ? trainingData.sections[trainingData.sections.length - 1].contents?.[
              trainingData.sections[trainingData.sections.length - 1].contents?.length - 1
          ]?.id
        : undefined;
    const lastSec = trainingData?.sections?.length
        ? trainingData.sections[trainingData.sections.length - 1].id
        : undefined;
    useEffect(() => {
        if (!isPublic) {
            actionFetchTrainingDetails(params.trainingId);
            setLoading(true);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (trainingDraft && typeof trainingDraft === 'object' && Object.keys(trainingDraft).length > 0) {
            setTrackingInfo({
                last_section_id: params.id,
                last_content_id: params.subId
            });
            setPlaybackObject(trainingDraft?.level_completion?.video_pause || []);
            setContentSaveInfo(trainingDraft.level_completion);
            if (!autoCompleteTriggered.current) {
                setLoading(false);
            }
            if (isInitialLoadRef.current) {
                const savedPage = trainingDraft.tracking_info?.last_page_number;

                if (Number.isInteger(savedPage) && savedPage >= 1) {
                    setPageNumber(savedPage);
                } else {
                    setPageNumber(1);
                }

                isInitialLoadRef.current = false;
            }
      const filteredSections = (trainingData?.sections || [])?.filter(section => section?.quiz !== null);
      const quizzArray = filteredSections?.map((obj, index) => ({
        id: obj.id,
        attempts: trainingDraft?.tracking_info?.attempts_used?.[index]?.attempts||1,
        total_reattempts: Number(trainingData?.sections[index].additional_config?.no_of_quiz_reattempts)||1,
        total_days: Number(trainingData?.sections[index].additional_config?.no_of_days_to_mandate)||1,
        reattempts_failure_days: Number(trainingData?.sections[index].additional_config?.no_of_days_to_mandate_for_reattempts_failure)|| 1,
        attempt_date: trainingDraft?.tracking_info?.attempts_used?.[index]?.attempt_date || new Date(),
        type: trainingData?.sections[index]?.additional_config?.whenQuizFail,
        final_result: trainingDraft?.tracking_info?.attempts_used?.[index]?.final_result,
        current_attempt_result: trainingDraft?.tracking_info?.attempts_used?.[index]?.current_attempt_result?.length>0
              && trainingDraft?.tracking_info?.attempts_used?.[index]?.current_attempt_result ==='fail' ? 'fail' : '',
        index,
        quizDraft: trainingDraft?.tracking_info?.attempts_used?.[index]?.quizDraft || {},
        shuffleQuiz: trainingDraft?.tracking_info?.attempts_used?.[index]?.shuffleQuiz || [],
        retake_fail_question: trainingDraft?.tracking_info?.attempts_used?.[index]?.retake_fail_question || false,
        failedQuestionIds: trainingDraft?.tracking_info?.attempts_used?.[index]?.failedQuestionIds || []
      }));
      let quizzID = (quizzArray || [])?.find(item => item?.id === Number(params?.id));
      let final_result='';
      if (quizzID?.attempts>=quizzID?.total_reattempts) {
        final_result = 'fail';
        quizzID = { ...quizzID, final_result };
      }
      const newAttempt = quizzArray?.map((obj) => {
        if (obj.id === Number(params.id)) {
          return { ...obj, ...quizzID };
        }
        return obj;
      });
      setCurrentQuizz(quizzID);
      setCurrentAttempts(newAttempt);
      // Total Quizzes in the training
      setTotalQuizz(trainingData?.sections.filter(section => section.quiz !== null));
        } else if (!isPublic && trainingFetchAction?.success === true) {
            actionTrainingDraft(params.trainingId);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [trainingDraft]);

    useEffect(() => {
        if (trainingFetchAction?.success === true && loading === true && !autoCompleteTriggered.current) {
            setLoading(false);
        }
        if (trainingFetchAction?.error === true && loading === true && !autoCompleteTriggered.current) {
            setLoading(false);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [trainingFetchAction]);

    useEffect(() => {
        if (trainingCompletionStatus === true) {
            setLoading(false);
            history.push(`${PORTAL}`);
        }
    }, [trainingCompletionStatus, history]);

    useEffect(() => {
        if (trainingCompletionError === true && autoCompleteTriggered.current) {
            setLoading(false);
            autoCompleteTriggered.current = true;
        }
    }, [trainingCompletionError]);

    let tempSectionId = false;
    let SubSecId = false;
    let handelSave = false;
    const sectionId = params.id;
    const subSectionId = params.subId;
    let parentSection = (trainingData?.sections || [])?.find(
        item => item?.id === parseInt(sectionId, 10)
    );
    const subSection = (parentSection?.contents || [])?.find(
        item => item?.id === subSectionId
    );

    /* Prev Next Logic Start */
    const sectionContentsLength = parentSection?.contents?.length || 0;
    const subSectionIdIndex = parentSection?.contents?.findIndex(
        item => item.id === subSectionId
    );
    const sectionIndex = trainingData?.sections?.findIndex(
        item => item.id === parseInt(sectionId, 10)
    );
    let nextSubSectionIndex = 0;
    let prevSubSectionIndex = 0;
    let nextSectionIndex = sectionIndex || 0;
    let prevSectionIndex = sectionIndex || 0;

    if (sectionContentsLength > 0) {
        if (subSectionIdIndex + 1 === sectionContentsLength) {
            nextSectionIndex = sectionIndex + 1;
        }
        if (sectionIndex > 0 && subSectionIdIndex === 0) {
            prevSectionIndex = sectionIndex - 1;
            prevSubSectionIndex = trainingData?.sections[prevSectionIndex]?.contents?.length - 1;
        }
        if (parentSection?.contents[subSectionIdIndex + 1]) {
            nextSubSectionIndex = subSectionIdIndex + 1;
        }
        if (parentSection?.contents[subSectionIdIndex - 1]) {
            prevSubSectionIndex = subSectionIdIndex - 1;
        }
    }
    const nextSectionId = trainingData?.sections[nextSectionIndex]?.id;
    const prevSectionId = trainingData?.sections[prevSectionIndex]?.id;
    const nextSubSectionId = trainingData?.sections[nextSectionIndex]?.contents[nextSubSectionIndex]?.id;
    const prevSubSectionId = trainingData?.sections[prevSectionIndex]?.contents[prevSubSectionIndex]?.id;

    /* Prev Next Logic End */
    const handleCompleteTraining = useCallback(() => {
        if (isPublic) {
            let allPassed = trainingDraft?.quiz_ans?.every(quiz => quiz.obtained_marks >= quiz.pass_marks);
            let payload = {
                status: allPassed || (trainingData?.sections || [])?.filter(item => item.quiz !== null)?.length === 0 ? 'pass' : 'fail'
            };
            completePublicTraining(trainingDraft?.id, payload);
        } else {
            actionCompleteTraining(trainingDraft?.id);
        }
        setLoading(true);
    }, [trainingDraft, actionCompleteTraining, isPublic, completePublicTraining, trainingData]);

    // Filter quiz_ans based on obtained_marks >= pass_marks and filter duplicates
    const filteredQuizAns = (trainingDraft?.quiz_ans || [])?.filter((quiz) => {
        const quizInfo = totalQuizz?.find(sec => sec.id === Number(quiz.section_id));
        return (
            quiz?.obtained_marks >= quiz?.pass_marks
            || quizInfo?.additional_config?.whenQuizFail === 'Re-attempts quiz for wrong answers only'
        );
    });
  const filteredAttemptsUsed = (trainingDraft?.quiz_ans || [])?.filter((quiz) => {
    // Find the corresponding attempts_used object
    const attemptsUsed = Array.isArray(trainingDraft?.tracking_info?.attempts_used)
        ? (trainingDraft?.tracking_info?.attempts_used || [])?.find(attempt => attempt?.id === Number(quiz?.section_id))
        : trainingDraft?.tracking_info?.attempts_used;
    // Check if attempts_used object exists and meets the condition
    return attemptsUsed && (attemptsUsed?.attempts || attemptsUsed) >= attemptsUsed?.total_reattempts;
  });
  let filter_quiz_ans = [];
  if ((filteredQuizAns && filteredQuizAns.length>0)|| (filteredAttemptsUsed && filteredAttemptsUsed.length>0)) {
    filter_quiz_ans = [...filteredQuizAns, ...filteredAttemptsUsed];
  }
  // filtering duplicates
  const filter_quizz = new Set();
  const uniqueQuizAns = (filter_quiz_ans || [])?.filter((obj) => {
    const { section_id } = obj;
    // If the id is not in the set, add it and include the object in the result
    if (!filter_quizz.has(section_id)) {
      filter_quizz.add(section_id);
      return true;
    }
    // If the id is in the set, exclude the object from the result
    return false;
  });

  const getFailedQuestionIds = (quizDraft, fields) => {
    const failed = [];

    Object.keys(quizDraft).forEach((qid) => {
      const field = fields.find(f => f.id === qid);
      if (!field) return;

      const selected = quizDraft[qid] || [];

      const correctAnswers = field.values
        .filter(v => v.correct_answer)
        .map(v => v.value.toLowerCase());

      const selectedNormalized = selected.map(a => a.toLowerCase());

      const isCorrect = correctAnswers.length === selectedNormalized.length
        && correctAnswers
          .sort()
          .every((val, i) => val === selectedNormalized.sort()[i]);

      if (!isCorrect) {
        failed.push(qid);
      }
    });

    return failed;
  };

    // Retake Logic

    const retakeTraining = async () => {
        const data = {};
        const latestAttempts = [...(currentAttempts || [])];
        let updated_attempt = latestAttempts[currentQuizz?.index];

        const failedIds = getFailedQuestionIds(
            updated_attempt?.quizDraft,
            parentSection?.quiz?.schema.fields
        );

        const newAttempt = {
            ...updated_attempt,
            attempt_date: new Date(),
            attempts: (updated_attempt?.attempts === updated_attempt?.total_reattempts
                && updated_attempt?.type === 'Re-attempts quiz for wrong answers only'
                && parentSection?.additional_config?.whenReattemptFail === 'Mandatory Wait Time until Reattempt'
                ? 0 : (updated_attempt?.attempts || 0)) + 1,
            current_attempt_result: '',
            retake_fail_question:
                updated_attempt?.type === 'Re-attempts quiz for wrong answers only',
            failedQuestionIds:
                updated_attempt?.type === 'Re-attempts quiz for wrong answers only'
                    ? failedIds
                    : [],
            quizDraft: {}
        };

        const updatedAttemptsArray = latestAttempts.map((obj) => {
            if (obj.index === currentQuizz?.index) {
                return newAttempt;
            }
            return obj;
        });

        setCurrentAttempts(updatedAttemptsArray);
        setCurrentQuizz(newAttempt);


        if (updated_attempt?.type === 'Re-attempts quiz for wrong answers only') {
            setRetakeTrigger(prev => prev + 1);
        }

        data.level_completion = trainingDraft?.level_completion;
        data.tracking_info = {
            last_section_id: sectionId,
            last_content_id: subSectionId,
            last_page_number: 1,
            attempts_used: trainingDraft?.tracking_info?.attempts_used ? updatedAttemptsArray : []
        };

        data.quiz_ans = uniqueQuizAns;
        await actionContentInfo(params?.trainingId, data);
        if (isPublic) {
            history.push(
                `/lms/start/training/${params?.backendId}/${params.airportCode.toUpperCase()}/${params.trainingId}/${sectionId
                }/${subSectionId}`
            );
        } else {
            history.push(
                `${TRAINING_MANAGEMENT_SECTION_DETAILS
                + (params?.trainingId)
                }/${sectionId
                }/${subSectionId}`
            );
        }
    };

    const handleSaveContent = async (quiz_data, schema_Id, form_Id, marks_data) => {
        let data = {};
        data.level_completion = {
            content_id: [
                ...(trainingDraft?.level_completion?.content_id || []),
                trackingInfo?.last_content_id
            ],
            section_id: [
                ...(trainingDraft?.level_completion?.section_id || []),
                trackingInfo?.last_section_id
            ]
        };
        let updated_attempt = currentAttempts?.[currentQuizz?.index];
        if (updated_attempt) {
            delete updated_attempt.retake_fail_question;
        }
        let present_marks_data;

        if (quizz && attempts_used && quizz.length > 0 && attempts_used.length > 0) {
            [present_marks_data] = quizz?.filter(quiz => updated_attempt.id === Number(quiz.section_id));
        }
        let quizz_marks_data = marks_data && marks_data.pass_marks ? marks_data: present_marks_data;
        if (quizz_marks_data && quizz_marks_data.pass_marks) {
            let result = '';
            if (Number(quizz_marks_data?.obtained_marks) >= Number(quizz_marks_data?.pass_marks)) {
                result = 'pass';
            } else if (
                currentQuizz?.attempts >= currentQuizz?.total_reattempts
                && Number(quizz_marks_data?.obtained_marks) < Number(quizz_marks_data?.pass_marks)
            ) {
                result = 'fail';
            }
            updated_attempt = {
                ...updated_attempt,
                current_attempt_result: Number(quizz_marks_data?.obtained_marks) >= Number(quizz_marks_data?.pass_marks) ? 'pass' : 'fail',
                final_result: result
            };
        }
        setCurrentQuizz(updated_attempt);
        updated_attempt = currentAttempts?.map((obj) => {
        if (obj.index === currentQuizz?.index) {
            return { ...obj, ...updated_attempt };
        }
        return obj;
        });

        if (subSectionId === lastSub && sectionId === lastSec) {
            data.tracking_info = {
                attempts_used: updated_attempt || 0
              };
        } else if (sectionId !== trainingData?.sections.slice(-1)[0]?.id) {
            data.tracking_info = {
                last_content_id: nextSubSectionId,
                last_section_id: nextSectionId,
                last_page_number: 1,
                attempts_used: updated_attempt || 0
            };
        } else {
            data.tracking_info = {
                last_content_id: nextSubSectionId,
                last_section_id: nextSectionId,
                last_page_number: 1,
                attempts_used: updated_attempt || 0
            };
        }

        if (quiz_data?.istrue) {
            data = { ...data,
                quiz_ans: [...trainingDraft.quiz_ans, {
                section_id: sectionId,
                schema_id: schema_Id,
                form_id: form_Id,
                ...marks_data,
                response: quiz_data.selectedAnswers,
                submited: true
            }]
        };
        } else if (quiz_data?.isedit) {
            const updatedQuizAnsArray = trainingDraft.quiz_ans.map((ele) => {
                const isMatch = Number(ele?.form_id) === Number(params?.subId)
                    && Number(ele?.section_id) === Number(params?.id);

                if (!isMatch) return ele;

                return {
                    ...ele,

                    // update marks
                    obtained_marks: marks_data.obtained_marks,
                    pass_marks: marks_data.pass_marks,

                    // merge responses with latest selected answers
                    response: {
                        ...ele.response,
                        ...quiz_data?.selectedAnswers
                    }
                };
            });
            data = {
                ...data,
                quiz_ans: updatedQuizAnsArray
            };
        } else {
            data = { ...data, quiz_ans: trainingDraft.quiz_ans };
        }

        await actionContentInfo(params.trainingId, data);
        setTrackingInfo({
            last_section_id: tempSectionId ? tempSectionId : nextSectionId,
            last_content_id: SubSecId ? SubSecId : nextSubSectionId
        });
        setContentSaveInfo(data.level_completion);
        setPageNumber(1);
        let lastSection = trainingData?.sections?.[trainingData?.sections?.length - 1];
        let flag = false;
        if (Number(lastSection?.contents?.[lastSection?.contents?.length - 1].id) === Number(params?.subId)) {
            flag = true;
        }
        if (handelSave && !flag) {
            if (isPublic) {
                history.push(
                    `/lms/start/training/${params?.backendId}/${params.airportCode.toUpperCase()}/${params.trainingId}/${nextSectionId
                    }/${nextSubSectionId}`
                );
            } else {
                history.push(
                    TRAINING_MANAGEMENT_SECTION_DETAILS
                    + params.trainingId
                    + '/'
                    + nextSectionId
                    + '/'
                    + nextSubSectionId
                );
            }
        }
    };

    const manageSectionRestricted = (sId) => {
        if (trainingData?.settings?.section_restricted) {
            const section = trainingData?.sections.find(sec => sec.id === Number(sectionId));
            const isCompleted = section.contents.every(content => (trainingDraft?.level_completion?.content_id || []).includes(String(content.id)));
            return trainingDraft?.level_completion?.section_id?.includes(sId.toString())
                || trainingDraft?.tracking_info?.last_section_id?.toString() === sId?.toString()
                || isCompleted;
        }
        return true;
    };

    const handleNextPrev = (isNext) => {
        if (subSection?.file_name?.split('.').pop() === 'pdf') {
            setPageNumber(
                isNext && pageNumber === numPages
                    ? 1
                    : isNext
                        ? pageNumber + 1
                        : pageNumber > 1
                            ? pageNumber - 1
                            : 1
            );
            if (
                (isNext && pageNumber === numPages) || (!isNext && pageNumber === 1)
            ) {
                saveTrackingInfo(
                    isNext ? nextSectionId : prevSectionId,
                    isNext ? nextSubSectionId : prevSubSectionId
                );
                if (isPublic) {
                    history.push(
                        `/lms/start/training/${params?.backendId}/${params.airportCode.toUpperCase()}/${params.trainingId}/${(
                        isNext ? nextSectionId : prevSectionId)
                        }/${(isNext ? nextSubSectionId : prevSubSectionId)}`
                    );
                } else {
                    history.push(
                        TRAINING_MANAGEMENT_SECTION_DETAILS
                        + params.trainingId
                        + '/'
                        + (isNext ? nextSectionId : prevSectionId)
                        + '/'
                        + (isNext ? nextSubSectionId : prevSubSectionId)
                    );
                }
            }
            const data = {};

      let updated_attempt = currentAttempts?.[currentQuizz?.index];
      setCurrentQuizz(updated_attempt);
      updated_attempt = currentAttempts?.map((obj) => {
        if (obj.index === currentQuizz?.index) {
          return { ...obj, ...updated_attempt };
        }
        return obj;
      });
            if (isNext && numPages !== pageNumber) {
                data.tracking_info = {
                    last_content_id: subSectionId,
                    last_section_id: sectionId,
                    last_page_number: pageNumber ? pageNumber + 1 : 1,
                    attempts_used: updated_attempt || 0
                };
                actionContentInfo(params.trainingId, data);
            }
            if (!isNext) {
                data.tracking_info = {
                    last_content_id: prevSubSectionId,
                    last_section_id: prevSectionId,
                    last_page_number: numPages === pageNumber ? pageNumber : pageNumber - 1,
                    attempts_used: updated_attempt || 0
                };
                actionContentInfo(params.trainingId, data);
            }
        } else if (parentSection?.quiz !== undefined && isNext) {
                let currentSection = (trainingData?.sections || []).filter(ele => Number(ele?.id) === Number(params?.id));
                let quiz = currentSection[0];
                // if is next is true and section contains quiz
                if (quiz?.quiz?.pass_marks && Number(quiz?.quiz?.id) === Number(params?.subId)) {
                    let remainingSections = [];
                    let flag = false;
                    for (let i = 0; i < trainingData.sections.length; i++) {
                        if (Number(trainingData.sections[i].id) === Number(params.id)) {
                            flag = true;
                        } else if (flag) {
                            remainingSections.push(trainingData.sections[i]);
                        }
                    }
                    setTracking([...tracking, { nextSectionId: remainingSections?.[0], nextSubSectionId: remainingSections?.[0]?.contents[0]?.id }]);
                    if (manageSectionRestricted(remainingSections?.[0]?.id)) {
                        if (isPublic) {
                            history.push(
                                `/lms/start/training/${params?.backendId}/${params.airportCode.toUpperCase()}/${params.trainingId
                                }/${(remainingSections?.[0]?.id)
                                }/${(remainingSections?.[0]?.contents[0]?.id)}`
                            );
                        } else {
                            history.push(
                                TRAINING_MANAGEMENT_SECTION_DETAILS
                                + params.trainingId
                                + '/'
                                + (remainingSections?.[0]?.id)
                                + '/'
                                + (remainingSections?.[0]?.contents[0]?.id)
                            );
                        }
                        tempSectionId = remainingSections?.[0]?.id;
                        SubSecId = remainingSections?.[0]?.contents?.[0]?.id;
                        let updated_attempt = currentAttempts?.[currentQuizz?.index];
                        setCurrentQuizz(updated_attempt);
                        updated_attempt = currentAttempts?.map((obj) => {
                            if (obj.index === currentQuizz?.index) {
                                return { ...obj, ...updated_attempt };
                            }
                            return obj;
                        });
                        const data = {};
                        data.tracking_info = {
                            last_content_id: SubSecId,
                            last_section_id: tempSectionId,
                            last_page_number: 1,
                            attempts_used: updated_attempt || 0
                        };
                        actionContentInfo(params.trainingId, data);
                    } else {
                        setOpenAlert(true);
                    }
                } else if (manageSectionRestricted(isNext ? nextSectionId : prevSectionId)) {
                    tempSectionId = false;
                    SubSecId = false;
                    saveTrackingInfo(
                        isNext ? nextSectionId : prevSectionId,
                        isNext ? nextSubSectionId : prevSubSectionId
                    );
                    setTracking([...tracking, { nextSectionId, nextSubSectionId }]);
                    if (isPublic) {
                        history.push(
                            `/lms/start/training/${params?.backendId}/${params.airportCode.toUpperCase()}/${params.trainingId
                            }/${(isNext ? nextSectionId : prevSectionId)
                            }/${(isNext ? nextSubSectionId : prevSubSectionId)}`
                        );
                    } else {
                        history.push(
                            TRAINING_MANAGEMENT_SECTION_DETAILS
                            + params.trainingId
                            + '/'
                            + (isNext ? nextSectionId : prevSectionId)
                            + '/'
                            + (isNext ? nextSubSectionId : prevSubSectionId)
                        );
                    }
                } else {
                    setOpenAlert(true);
                }
                setNumPages(null);
            } else if (!isNext) {
                if (isPublic) {
                    history.push(
                        `/lms/start/training/${params?.backendId}/${params.airportCode.toUpperCase()}/${params.trainingId
                        }/${(isNext ? nextSectionId : prevSectionId)
                        }/${(isNext ? nextSubSectionId : prevSubSectionId)}`
                    );
                } else {
                    history.push(
                        TRAINING_MANAGEMENT_SECTION_DETAILS
                        + params.trainingId
                        + '/'
                        + (isNext ? nextSectionId : prevSectionId)
                        + '/'
                        + (isNext ? nextSubSectionId : prevSubSectionId)
                    );
                }
            } else if ((manageSectionRestricted(isNext ? nextSectionId : prevSectionId))) {
                tempSectionId = false;
                SubSecId = false;
                saveTrackingInfo(
                    isNext ? nextSectionId : prevSectionId,
                    isNext ? nextSubSectionId : prevSubSectionId
                );
                setTracking([...tracking, { nextSectionId, nextSubSectionId }]);
                if (isPublic) {
                    history.push(
                        `/lms/start/training/${params?.backendId}/${params.airportCode.toUpperCase()}/${params.trainingId
                        }/${(isNext ? nextSectionId : prevSectionId)
                        }/${(isNext ? nextSubSectionId : prevSubSectionId)}`
                    );
                } else {
                    history.push(
                        TRAINING_MANAGEMENT_SECTION_DETAILS
                        + params.trainingId
                        + '/'
                        + (isNext ? nextSectionId : prevSectionId)
                        + '/'
                        + (isNext ? nextSubSectionId : prevSubSectionId)
                    );
                }
                setNumPages(null);
            } else {
                setOpenAlert(true);
            }
        setPlaybackTimeSet(true);
    };

    const saveTrackingInfo = () => {
        setLoading(false);
        if (subSection?.content_type?.includes('video/mp4') || subSection?.file_name?.split('.').pop() === 'mp4');
        else handleSaveContent();
    };

    const displaySaveButton = !(
        contentSaveInfo?.content_id?.includes(subSectionId) && contentSaveInfo?.section_id?.includes(sectionId)
    );

    const getStatus = () => {
        let lastSection = trainingData?.sections?.[trainingData?.sections?.length - 1];
        if (Number(lastSection?.contents?.[lastSection?.contents?.length - 1].id) === Number(params?.subId)) {
            return true;
        } else {
            return false;
        }
    };

    const toggle = () => {
        let data = trainingData?.sections?.[trainingData?.sections?.length - 1];
        data = data?.contents?.[data?.contents?.length - 1];
        let finalSection = trainingData?.sections[trainingData?.sections?.length - 1];
        const finalContents = finalSection?.contents[finalSection.contents.length - 1];
        if (Number(data?.quiz?.id) === Number(params?.subId)) {
            return false;
        } else if (Number(finalSection?.id) === Number(params?.id) && Number(finalContents.id) === Number(params?.subId)) {
            return false;
        } else { return true; }
    };

  const noQuizz = useMemo(
    () => trainingData?.sections?.filter(item => item?.quiz !== null),
    [trainingData]
  );

  // Callback function to receive data from the child
  const handleQuizzStatus = (data, result) => {
    setQuizzStatus(data);
    setQuizzResult(result);
  };

  const attempts_used = trainingDraft?.tracking_info?.attempts_used;
    const {
        quizz,
        filteredOnlyAttempts,
        allPass,
        allComplete
    } = useMemo(() => {
        const temQuizz = trainingDraft?.quiz_ans || [];

        let tempFilteredQuizz = [];
        let tempFilteredOnlyAttempts = [];
        let tempAllPass = false;
        let tempAllComplete = true;

        if (temQuizz.length > 0) {
            const contentIds = trainingDraft?.level_completion?.content_id || [];
            const sectionIds = trainingDraft?.level_completion?.section_id || [];

            const sectionContentPairSet = new Set(
                contentIds.map((contentId, index) => `${contentId?.toString()}_${sectionIds[index]?.toString()}`)
            );

            tempFilteredQuizz = temQuizz.filter(quiz => sectionContentPairSet.has(
                `${quiz.form_id?.toString()}_${quiz.section_id?.toString()}`
            ));

            tempFilteredOnlyAttempts = [
                ...new Set(
                    contentIds
                        .map((contentId, index) => {
                            const attempt = temQuizz.find(
                                q => q.form_id?.toString() === contentId?.toString()
                                    && q.section_id?.toString() === sectionIds[index]?.toString()
                            );

                            return attempt
                                ? `${contentId}_${sectionIds[index]}`
                                : null;
                        })
                        .filter(Boolean)
                )
            ];
        }

        tempAllPass = tempFilteredQuizz.length > 0
            && tempFilteredQuizz.every(
                item => item.obtained_marks >= item.pass_marks
            );

        tempAllComplete = true;

        if (trainingData?.sections) {
            trainingData.sections.forEach((section) => {
                if (section?.contents) {
                    section.contents.forEach((content) => {
                        if (
                            !trainingDraft?.level_completion?.content_id?.includes(
                                content?.id?.toString()
                            )
                        ) {
                            tempAllComplete = false;
                        }
                    });
                }
            });
        }

        return {
            quizz: temQuizz,
            filteredOnlyAttempts: tempFilteredOnlyAttempts,
            allPass: tempAllPass,
            allComplete: tempAllComplete
        };
    }, [trainingDraft, trainingData]);

    const retakeSection = async () => {
        const data = {};
        let updated_attempt = currentAttempts?.[currentQuizz?.index];
        updated_attempt = {
            ...updated_attempt,
            attempt_date: new Date(),
            attempts: updated_attempt?.attempts + 1,
            current_attempt_result: '',
            quizDraft: {}
        };
        updated_attempt = currentAttempts?.map((obj) => {
            if (obj.index === currentQuizz?.index) {
                return { ...obj, ...updated_attempt };
            }
            return obj;
        });
        if (isPublic) {
            history.push(
                `/lms/start/training/${params?.backendId}/${params.airportCode.toUpperCase()}/${params.trainingId}/${sectionId
                }/${parentSection?.contents[0]?.id}`
            );
        } else {
            history.push(
                `${TRAINING_MANAGEMENT_SECTION_DETAILS
                + (params?.trainingId)
                }/${sectionId
                }/${parentSection?.contents[0]?.id}`
            );
        }
        data.tracking_info = {
            last_content_id: parentSection?.contents[0]?.id,
            last_section_id: sectionId,
            last_page_number: 1,
            attempts_used: trainingDraft?.tracking_info?.attempts_used ? updated_attempt : 1
        };

        // clear specific section id and content id from level completion to retake section
        const indices = trainingDraft?.level_completion?.section_id.reduce((acc, currentValue, index) => {
            if (currentValue === sectionId) {
                acc.push(index);
            }
            return acc;
        }, []);

        data.level_completion = {
            content_id: trainingDraft?.level_completion?.content_id.filter((_, index) => !indices.includes(index)),
            section_id: trainingDraft?.level_completion?.section_id.filter((_, index) => !indices.includes(index))
        };

        data.quiz_ans = [];
        await actionContentInfo(params?.trainingId, data);
    };

    useEffect(() => {
        const watch_time = (subSection?.content_type?.includes('video/mp4') || subSection?.file_name?.split('.').pop() === 'mp4');
        if (watch_time) {
            const next_sections = subSection?.settings?.next_section;
            const skip_videos = subSection?.settings?.video_skip;
            const videoElement = playerRef?.current.getInternalPlayer();
            if (videoElement && !skip_videos) {
                videoElement.classList.add('skip_video');
            }
            const watch_video = watch_time && !skip_videos
            ? (Array.isArray(playbackObject) ? playbackObject : [])?.find(item => item?.content_id === params?.subId)?.isCompleted
            : true;
            const watch_video2 = !next_sections ? watch_video : next_sections;
            setWatchTime(!watch_video);
            setNext_Section(watch_video2);
        }
    }, [playbackObject, subSection, params]);

    const handleReady = () => {
        const videoElement = playerRef?.current?.getInternalPlayer();
        if (videoElement && videoControls) {
            videoElement.controlsList.add('nodownload');
            setvideoControls(false);
        }
        if (playerRef?.current && playbackObject?.length > 0 && playbackTimeSet) {
            const presentValue = (playbackObject || [])?.find(item => item?.content_id === params?.subId)?.pause_time ?? 0.00;
            playerRef.current.seekTo(presentValue);
            setPlaybackTimeSet(false);
        }
    };

    const handlePause = async () => {
        if (playerRef?.current) {
            const currentTime = playerRef?.current.getCurrentTime();
            const duration = playerRef?.current.getDuration();
            const ended = +currentTime === +duration;
            handleTime(currentTime, ended);
        }
    };

    const handleEnded = async () => {
        if (!isPublic) {
            await actionFetchTrainingDetails(params.trainingId);
        }
    };

    const handleTime = (value, completed) => {
            let data = {};

        const levelCompletion = playbackObject;
        const existingIndex = levelCompletion.findIndex(pause => pause.content_id === params.subId);

        if (existingIndex !== -1) {
            levelCompletion[existingIndex].pause_time = value;
            levelCompletion[existingIndex].isCompleted = completed ?? false;
        } else {
            levelCompletion.push({
            content_id: params.subId,
            pause_time: value,
            isCompleted: completed || false
            });
        }

        data.level_completion = { ...trainingDraft.level_completion, video_pause: levelCompletion };
        actionContentInfo(params?.trainingId, data);
        setPlaybackObject(levelCompletion);
        setPlaybackTimeSet(true);
    };

    useEffect(() => {
        const element = document.querySelector('body');
        if (element.classList.contains('modal-open')) {
            element.classList.remove('modal-open');
        }
    }, [loading]);

    const handleSaveQuizDraft = async (quizInfo) => {
        let payload = {};
        const trackingData = trainingDraft?.tracking_info;
        let updated_attempt = currentAttempts?.[currentQuizz?.index];
        updated_attempt = { ...updated_attempt, quizDraft: quizInfo };
        updated_attempt = currentAttempts?.map((obj) => {
            if (obj.index === currentQuizz?.index) {
                return { ...obj, ...updated_attempt };
            }
            return obj;
        });
        payload.tracking_info = {
            ...trackingData,
            attempts_used: trainingDraft?.tracking_info?.attempts_used ? updated_attempt : []
        };
        await actionContentInfo(params?.trainingId, payload);
    };

    const handleSaveQuizShuffle = async (quiz) => {
        let payload = {};
        const trackingData = trainingDraft?.tracking_info;
        let updated_attempt = currentAttempts?.[currentQuizz?.index];
        updated_attempt = { ...updated_attempt, shuffleQuiz: quiz };
        updated_attempt = currentAttempts?.map((obj) => {
            if (obj.index === currentQuizz?.index) {
                return { ...obj, ...updated_attempt };
            }
            return obj;
        });
        payload.tracking_info = {
            ...trackingData,
            attempts_used: trainingDraft?.tracking_info?.attempts_used ? updated_attempt : []
        };
        await actionContentInfo(params?.trainingId, payload);
    };

    const isQuizCompleted = useMemo(() => {
        // Check if any object in the array has "final_result" equal to 'fail' or 'pass' but not ''
        if (totalQuizz && totalQuizz.length > 0) {
            if (!filteredOnlyAttempts || totalQuizz.length !== filteredOnlyAttempts.length) {
                return false;
            }
            const quizResult = (quizz || []).map((quiz) => {
                let final_result = '';

                if (
                    quiz.obtained_marks !== undefined
                    && quiz.pass_marks !== undefined
                ) {
                    final_result = Number(quiz.obtained_marks) >= Number(quiz.pass_marks)
                        ? 'pass'
                        : 'fail';
                }

                return {
                    ...quiz,
                    final_result
                };
            });

            const hasValidFinalResult = quizResult.every(item => ['fail', 'pass'].includes(item.final_result));

            return hasValidFinalResult;
        }
        return true;
    }, [totalQuizz, filteredOnlyAttempts, quizz]);


    const checkRecheckQuizz = () => {
        if (!subSection && quizz?.length > 0) {
            const quiz = quizz?.find(item => Number(item.section_id) === currentQuizz?.id);
            if ((currentQuizz?.type === 'Re-attempts Allowed'
                || currentQuizz?.type === 'Re-attempts quiz for wrong answers only')
                && Number(currentQuizz?.total_reattempts) >= Number(currentQuizz?.attempts)
                && Number(quiz?.obtained_marks) < Number(quiz?.pass_marks)
                && currentQuizz?.final_result !== 'fail') {
                if (currentQuizz?.retake_fail_question) {
                    return false;
                }
                return true;
            }
            if (currentQuizz?.type === 'Re-attempts quiz for wrong answers only'
                && parentSection?.additional_config?.whenReattemptFail === 'Mandatory Wait Time until Reattempt'
                && Number(quiz?.obtained_marks) < Number(quiz?.pass_marks)
                && currentQuizz?.final_result === 'fail'
                && Number(currentQuizz?.attempts) === Number(currentQuizz?.total_reattempts)
                && (new Date().getTime() - new Date(currentQuizz?.attempt_date).getTime()) / (1000 * 60 * 60 * 24)
                > Number(currentQuizz?.reattempts_failure_days)) {
                return true;
            }
            if (currentQuizz?.type === 'Mandatory Wait Time until Test can be Retaken'
                && (new Date().getTime() - new Date(currentQuizz?.attempt_date).getTime()) / (1000 * 60 * 60 * 24)
                > Number(currentQuizz?.total_days)) {
                return true;
            }
        }
        return false;
    };

    const validateReattemptTimer = () => {
    if (parentSection?.additional_config?.no_of_days_to_mandate_for_reattempts_failure
      && parentSection?.additional_config?.whenQuizFail === 'Re-attempts quiz for wrong answers only'
      && parentSection?.additional_config?.whenReattemptFail === 'Mandatory Wait Time until Reattempt'
      && !(Number(currentQuizz?.obtained_marks)>=Number(currentQuizz?.pass_marks))
      && (new Date().getTime() - new Date(currentQuizz?.attempt_date).getTime()) / (1000 * 60 * 60 * 24)
      < Number(parentSection?.additional_config?.no_of_days_to_mandate_for_reattempts_failure)) {
      return true;
    }
    return false;
  };

    const shouldMarkComplete = useMemo(() => {
        if (Object.keys(trainingDraft || {}).length === 0 || loading) return false;

        return (
            allComplete
            && (allPass || noQuizz?.length === 0)
            && isQuizCompleted
        );
    }, [allComplete, allPass, noQuizz, isQuizCompleted, loading, trainingDraft]);


    useEffect(() => {
        if (!shouldMarkComplete) return;

        if (!autoCompleteTriggered.current) {
            autoCompleteTriggered.current = true;
            handleCompleteTraining();
        }
    }, [shouldMarkComplete, handleCompleteTraining]);


    return (
        <div className={styles.sectionDetails}>
            <HeaderBack
                translationID="training.back.dashboard"
                translationDefault="Back"
                backRoute={PORTAL}
                customStyles={styles.backToDash}
            />
            {!trainingPermission && (
                <div className={styles.headerRight}>
                    {((subSection?.file_name?.split('.').pop() === 'pdf'
                        && pageNumber > 1)
                        || (!(sectionIndex === 0 && subSectionIdIndex === 0)
                            && prevSectionId
                            && prevSubSectionId))
                        && showPrevious(
                            parentSection?.additional_config,
                            parentSection?.quiz,
                            params.subId
                        ) && (
                            <span className={styles.prev} onClick={() => handleNextPrev(false)}>
                                <NavigateBefore />
                                Previous
                            </span>
                        )}
                    {(toggle() || pageNumber < numPages) && (next_section)
                        && (
                            <span className={styles.next} onClick={() => handleNextPrev(true)}>
                                Next <NavigateNext />
                            </span>
                        )
                    }
                </div>
            )}
            <Loading loadingStatus={loading} />
            {!trainingPermission && (isPublic || trainingFetchAction?.success === true) && (
                <>
                    <div className={styles.sectionList}>
                        <SectionsList
                            {...props}
                            margin
                            setPlaybackTimeSet={setPlaybackTimeSet}
                            isPublic={isPublic}
                            actiontTrainingDraft={actionTrainingDraft}
                            trainingData={trainingData}
                            trainingDraft={trainingDraft}
                            actionContentInfo={actionContentInfo}
                        />
                    </div>
                    <div className={styles.sectionData}>
                        <div className={styles.detailsSection}>
                            <h2 style={{ fontSize: '1.5rem', fontWeight: '550' }}>
                                {subSection?.name || subSection?.file_name || parentSection?.quiz?.title || 'Content'}
                            </h2>
                            <div className={styles.contentWrap}>
                                {subSection ? (
                                    subSection.file_name ? (
                                        subSection?.file_name?.split('.').pop() === 'mp4'
                                            || subSection?.file_name?.split('.').pop() === 'mp3' ? (
                                            <ReactPlayer
                                                url={subSection?.url}
                                                width="100%"
                                                height="550px"
                                                controls
                                                onReady={handleReady}
                                                ref={playerRef}
                                                onContextMenu={e => e.preventDefault()}
                                                onPause={handlePause}
                                                onEnded={handleEnded}
                                            />
                                        ) : (
                                            subSection?.file_name?.split('.').pop() === 'pdf' ? (
                                                <div>
                                                    <div className={styles.docViwer}>
                                                        <DisplayPDF
                                                            pdf={{
                                                                id: 1,
                                                                preview: subSection?.url,
                                                                url: subSection?.url,
                                                                file_name: subSection?.file_name
                                                            }}
                                                            handleNextPrev={
                                                                handleNextPrev
                                                            }
                                                            setNumPages={setNumPages}
                                                            pageNumberProps={pageNumber}
                                                            nextSectionId={nextSectionId}
                                                            subSection={subSection}
                                                            toggle={toggle}
                                                            next_section={next_section}
                                                            sectionIndex={sectionIndex}
                                                            subSectionIdIndex={subSectionIdIndex}
                                                            prevSectionId={prevSectionId}
                                                            prevSubSectionId={prevSubSectionId}
                                                            showPrevious={showPrevious}
                                                            parentSection={parentSection}
                                                            params={params}
                                                            numPagesProps={numPages}
                                                        />
                                                    </div>
                                                </div>
                                                ) : (subSection?.file_name?.split('.').pop() === 'ppt'
                                                    || subSection?.file_name?.split('.').pop() === 'pptx') && (
                                                <div className={styles.pptrenderer}>
                                                    <div className={styles.docViwer}>
                                                        <DocumentViewer
                                                            queryParams="hl=Nl"
                                                            url={subSection.url && subSection.url}
                                                            overrideLocalhost="https://react-doc-viewer.firebaseapp.com/"
                                                        />
                                                    </div>
                                                </div>
                                            )
                                        )
                                    ) : subSection.type === 'url' ? (
                                        <a href={subSection.url} target="_blank" rel="noopener noreferrer">{subSection.name}</a>
                                    ) : subSection.type === 'video' && (
                                        <>
                                            <div
                                                // eslint-disable-next-line react/no-danger
                                                dangerouslySetInnerHTML={{ __html: subSection.video }}
                                            />
                                        </>
                                    )
                                )
                                    : (
                                        <>
                                            {trainingData && parentSection?.quiz !== undefined && currentQuizz
                                                ? <StartQuiz
                                                    key={retakeTrigger}
                                                    retakeTrigger={retakeTrigger || currentQuizz?.retake_fail_question}
                                                    {...props}
                                                    quizData={parentSection?.quiz}
                                                    handleSaveContent={handleSaveContent}
                                                    trainingData={trainingData}
                                                    currentQuizz={currentQuizz}
                                                    handleQuizzStatus={handleQuizzStatus}
                                                    params={params}
                                                    additional_config={parentSection?.additional_config}
                                                    retakeSection={retakeSection}
                                                    trainingDraft={trainingDraft}
                                                    isPublic={isPublic}
                                                    loadingStatus={isPublic ? true : false}
                                                    handleSaveQuizDraft={handleSaveQuizDraft}
                                                    handleSaveQuizShuffle={handleSaveQuizShuffle}
                                                />
                                                : <div className={styles.emptyData}>Content not available</div>
                                            }
                                        </>
                                    )}
                            </div>
                        </div>
                        {
                            ((Number(subSectionId) === Number(lastSub) && Number(lastSec) === Number(sectionId)) && allComplete && ((quizzStatus
                                && (currentQuizz?.attempts === currentQuizz?.total_reattempts
                                    || quizzResult) && isQuizCompleted) || noQuizz?.length === 0))
                            && !validateReattemptTimer() && !checkRecheckQuizz() && (
                                getStatus()
                                && (
                                    <div>
                                        {(currentQuizz?.type !== 'Mandatory Wait Time until Test can be Retaken' || allPass) && (
                                            <Button
                                                action="secondary"
                                                translationID="markascompleted"
                                                defaultText={'Reschedule'}
                                                className={styles.completeButton}
                                                onClick={handleCompleteTraining}
                                                disabled={loading}
                                            />
                                        )}
                                    </div>
                                ))
                        }
                        {checkRecheckQuizz()
                            && <Button
                                onClick={() => { retakeTraining(); }}
                                translationID="lms.add.quiz.finish1"
                                defaultText="Retake"
                                className={styles.completeButton}
                            />
                        }
                        {displaySaveButton && Number(parentSection?.quiz?.id) !== Number(params?.subId) && !watchTime && (
                            <Button
                                action="secondary"
                                translationID="save"
                                defaultText="Save"
                                className={styles.completeButton}
                                onClick={() => {
                                    handelSave = true;
                                    handleSaveContent();
                                }}
                                disabled={loading}
                            />
                        )}
                    </div>
                </>
            )}
            {trainingPermission && (
                <div className={styles.noData}>
                    <span className={styles.noDataText}>
                        <FormattedMessage
                            id="documents.no_permission.message"
                            defaultMessage="You do not have permission for portal training to perform any action."
                        />
                    </span>
                </div>
            )}
            <Modal showIn={openAlert} onClose={() => { setOpenAlert(false); }} width="300px" minHeight="auto">
                {/* headder */}
                <div className={styles.headder}>
                    <h3 className={styles.alertText}>
                        <FormattedMessageWithClass id="alert" defaultMessage="Alert" />
                    </h3>
                </div>
                {/* body */}
                <div className={styles.body}>
                    <FormattedMessageWithClass
                        id="lms.alert.section.restricted"
                        defaultMessage="This section is locked. Please complete the previous section to continue."
                    />
                </div>
                {/* footer */}
                <div className={styles.footer}>
                    <Button
                        className={styles.cancleBtn}
                        translationID="sms.form.cancel"
                        defaultText="Cancel"
                        onClick={() => { setOpenAlert(false); }}
                    />
                </div>
            </Modal>
        </div>
    );
};

export default TrainingDetail;
